import React, { Component } from "react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import Last4SSN from "~/components/traffic/lookup/Forms/Inputs/Last4SSN"
import Tooltip from "~/components/Tooltip"
import withTranslations from "~/components/_hocs/withTranslations"

import DropdownMenu from "../DropdownMenu"
import InputTitle from "./InputTitle"

const InputItemWrapper = styled.div`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  ${(props) =>
    props.$compact &&
    `
    display: flex;
    flex-direction: column;
    gap: 10px;
  `}
`

const CompactLabel = styled.label`
  font-family: ${(props) => props.theme.fonts.avenirNextMedium};
  font-size: 0.9375rem;
  height: 21px;
  display: flex;
  align-items: center;
  color: #374553;
`

class SSNInput extends Component {
  render() {
    const compact = this.props.compact
    return (
      <InputItemWrapper $compact={compact}>
        {compact ? (
          <CompactLabel>{this.props.translate("label")}</CompactLabel>
        ) : (
          <>
            <InputTitle>
              {this.props.translate("label")}
              <Tooltip
                message={this.props.translate("tooltip")}
                icon="question"
                size={21}
              />
              <Spacer direction="width" mobile={11} desktop={11} />
              <DropdownMenu columnNumber="two" />
            </InputTitle>
            <Spacer desktop={10} mobile={4} />
          </>
        )}
        <Last4SSN
          submitButtonRef={this.props.submitButtonRef}
          compact={compact}
        />
      </InputItemWrapper>
    )
  }
}

export default withTranslations(SSNInput, "form.traffic.lastFourSSN")
